import ReactDOM from "react-dom"
import React, { Component } from "react"

export class Portal extends Component {
  constructor(props) {
    super(props)

    this.modalRoot = document.createElement("div")
  }

  componentDidMount() {
    document.body.appendChild(this.modalRoot)

    window.addEventListener("keydown", this.handleKey)
  }

  componentWillUnmount() {
    document.body.removeChild(this.modalRoot)
    window.removeEventListener("keydown", this.handleKey)
  }

  handleKey = e => {
    const { onClose, isVisible } = this.props
    if (e.which === 27 && isVisible) {
      onClose()
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.modalRoot)
  }
}
